import React from 'react'
import PropTypes from 'prop-types'

export default class Card extends React.Component {
  render() {
    const { children, title, ariaLabel, role = 'region', ...rest } = this.props

    const cardId = title ? `card-${Math.random().toString(36).substr(2, 9)}` : undefined
    const titleId = title ? `${cardId}-title` : undefined

    return (
      <div className="card" role={role} aria-label={ariaLabel} aria-labelledby={titleId} {...rest}>
        <div className="card-body">
          {title && (
            <h3 id={titleId} className="sr-only">
              {title}
            </h3>
          )}
          {children}
        </div>
      </div>
    )
  }
}

Card.propTypes = {
  children: PropTypes.node.isRequired,
  title: PropTypes.string,
  ariaLabel: PropTypes.string,
  role: PropTypes.string,
}
